import ArgumentAssertionBuilder from './ArgumentAssertionBuilder';
import ArgumentException from '../Exceptions/ArgumentException';
export default class ArrayLikeArgumentAssertionBuilder extends ArgumentAssertionBuilder {
    /** Ensures the array is not null, undefined or empty */
    isNotNullOrUndefinedOrEmpty() {
        return this.isNotNullOrUndefined().isNotEmpty();
    }
    /** Ensures the array is not empty */
    isNotEmpty() {
        if (this.argument.length == 0) {
            throw new ArgumentException(this.argumentName);
        }
        return this;
    }
}
